import { useState } from "react";
import { Download, X, Share, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { usePWA } from "@/hooks/usePWA";

export function InstallPrompt() {
  const { isInstallable, isInstalled, isIOS, promptInstall } = usePWA();
  const [dismissed, setDismissed] = useState(false);

  // Don't show if already installed or dismissed
  if (isInstalled || dismissed) return null;

  // Show iOS instructions
  if (isIOS && !isInstallable) {
    return (
      <Card className="fixed bottom-4 left-4 right-4 z-50 bg-primary text-primary-foreground shadow-xl animate-in slide-in-from-bottom-4">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <p className="font-semibold mb-1">Instalar Altus Food</p>
              <p className="text-sm opacity-90 mb-2">
                Adicione à tela inicial para acesso rápido:
              </p>
              <ol className="text-xs opacity-80 space-y-1">
                <li className="flex items-center gap-1">
                  1. Toque em <Share className="h-3 w-3 inline" /> Compartilhar
                </li>
                <li className="flex items-center gap-1">
                  2. Role e toque em <Plus className="h-3 w-3 inline" /> Adicionar à Tela Inicial
                </li>
              </ol>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="text-primary-foreground hover:bg-primary-foreground/20 -mt-1 -mr-1"
              onClick={() => setDismissed(true)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  // Show install button for Android/Desktop
  if (!isInstallable) return null;

  return (
    <Card className="fixed bottom-4 left-4 right-4 z-50 bg-primary text-primary-foreground shadow-xl animate-in slide-in-from-bottom-4">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <p className="font-semibold">Instalar Altus Food</p>
            <p className="text-sm opacity-80">
              Acesse mais rápido direto da tela inicial
            </p>
          </div>
          <Button
            variant="secondary"
            size="sm"
            className="gap-1"
            onClick={promptInstall}
          >
            <Download className="h-4 w-4" />
            Instalar
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="text-primary-foreground hover:bg-primary-foreground/20"
            onClick={() => setDismissed(true)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
